import type { SubMarket, SubMarketBundle } from './types'

/**
 * Parent `getAllSubMarket` polls replace `subMarketDetails` with a new object
 * every tick. Blind replace races live Rate/Suspend socket updates and makes
 * the Suspend toggle blink (e.g. stale isSuspended:true after a rate click).
 *
 * Same market → keep live toggle + line fields from the open ScoreDashboard;
 * take catalog/meta from the parent fetch.
 */
export function mergeScoreboardParentSync(
  prev: SubMarketBundle,
  next: SubMarketBundle,
): SubMarketBundle {
  const prevSm = prev.subMarketDetails
  const nextSm = next.subMarketDetails
  const sameMarket =
    String(prevSm?.marketId || '') !== '' &&
    String(prevSm.marketId) === String(nextSm?.marketId || '')

  if (!sameMarket) {
    return {
      subMarketShow: next.subMarketShow,
      subMarketDetails: nextSm,
      rateList: next.rateList,
      runList: next.runList,
    }
  }

  const live: Partial<SubMarket> = {
    isSuspended: prevSm.isSuspended,
    isMarketSuspended: prevSm.isMarketSuspended,
    ballChalu: prevSm.ballChalu,
    fancyCommission: prevSm.fancyCommission,
    status: prevSm.status,
    rateBack: prevSm.rateBack,
    rateLay: prevSm.rateLay,
    horseBack: prevSm.horseBack,
    horseLay: prevSm.horseLay,
    runButtonValue: prevSm.runButtonValue,
    notification: prevSm.notification,
  }

  return {
    subMarketShow: next.subMarketShow,
    rateList: next.rateList,
    runList: next.runList,
    subMarketDetails: { ...nextSm, ...live },
  }
}
